import {
  createShopApiGraphqlClient,
  type ShopApiGraphqlClient,
} from "../../../../packages/pvc-product/shop-api-transport";

export type BusinessQuoteSubmission = {
  name: string;
  organization?: string;
  phone: string;
  details: string;
  requestedProduct?: string;
  website?: string;
};

const SUBMIT_BUSINESS_QUOTE = `
  mutation HappyPrintSubmitBusinessQuote($input: HappyPrintBusinessQuoteInput!) {
    submitHappyPrintBusinessQuote(input: $input) {
      __typename
      ... on HappyPrintBusinessQuoteAccepted { ok }
      ... on HappyPrintBusinessQuoteRejected { ok field message }
    }
  }
`;

function object(value: unknown, path: string): Record<string, unknown> {
  if (value == null || typeof value !== "object" || Array.isArray(value)) {
    throw new Error(`${path} must be an object`);
  }
  return value as Record<string, unknown>;
}

export class BusinessQuoteSubmissionError extends Error {
  constructor(
    public readonly field: string | null,
    message: string,
  ) {
    super(message);
    this.name = "BusinessQuoteSubmissionError";
  }
}

export function createBusinessQuoteApi(client: ShopApiGraphqlClient) {
  return {
    async submit(input: BusinessQuoteSubmission): Promise<void> {
      const raw = await client.execute({
        operationName: "HappyPrintSubmitBusinessQuote",
        document: SUBMIT_BUSINESS_QUOTE,
        variables: { input },
      });
      const root = object(raw, "data");
      const result = object(
        root.submitHappyPrintBusinessQuote,
        "data.submitHappyPrintBusinessQuote",
      );
      if (result.__typename === "HappyPrintBusinessQuoteAccepted" && result.ok === true) {
        return;
      }
      if (result.__typename === "HappyPrintBusinessQuoteRejected") {
        throw new BusinessQuoteSubmissionError(
          typeof result.field === "string" ? result.field : null,
          typeof result.message === "string" ? result.message : "הבקשה לא התקבלה.",
        );
      }
      throw new Error("Unexpected business quote response");
    },
  };
}

export function createBrowserBusinessQuoteApi() {
  const endpoint = import.meta.env.VITE_SHOP_API_URL || "/shop-api";
  return createBusinessQuoteApi(createShopApiGraphqlClient({ endpoint }));
}
